import isEmpty from 'lodash/isEmpty';
import { isValidUrl } from '@atlassian/jira-common-util-is-url/src/index.tsx';

export const allowedSchemes = ['http:', 'https:'];

export const validateURLField = (
	value: string | undefined,
	isRequired: boolean,
	checkScheme: boolean,
): string | undefined => {
	if (!value) {
		return isRequired ? validationErrorMessages.empty : undefined;
	}
	const trimmedValue = value?.trim();
	if (isEmpty(trimmedValue) && isRequired) {
		return validationErrorMessages.empty;
	}

	if (!isEmpty(trimmedValue) && !isValidUrl(value)) {
		return validationErrorMessages.urlInvalid;
	}
	if (checkScheme && !allowedSchemes.some((scheme) => value.startsWith(scheme))) {
		return validationErrorMessages.urlSchemeInvalid;
	}

	return undefined;
};

export const validateSupportedScopes = (
	chosenScopes: string[],
	supportedScopes: string[],
): string | undefined => {
	const invalidScopes = chosenScopes.filter((scope) => !supportedScopes.includes(scope));
	if (invalidScopes.length > 0) {
		return validationErrorMessages.unsupportedScope;
	}

	return undefined;
};

export const validationErrorMessages = {
	empty: 'This field is required.',
	urlInvalid: 'Enter a valid URL.',
	urlSchemeInvalid: 'The URL must start with http:// or https://.',
	authTypeInvalid: 'Select a valid authentication type.',
	impersonationNotAllowed:
		'2LO (impersonation) is deprecated. Please choose another authentication type.',
	unsupportedScope: 'One or more selected scopes are not supported.',
};
